import OadpCardDivider from './oadp-card-divider';
export default OadpCardDivider;
